import { defineFcm } from '../shared/factory';

export const FCM_SEARCH_DM_CARD_ENABLED = defineFcm('search_dm_card_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		supportedGroups: { global: true, locales: true },
		context: 'Search page',
		description: `Shows a decision maker card above the search results when the query strongly matches a decision maker (e.g. "gavin newsom").

		Enable per locale as the card's translations become available, or globally once every locale is covered. When off, the search page doesn't query the decision_makers collection at all.`,
	});
